import { getEnv } from '../common/lib/getEnv';
import { Environment } from '../types/Environment';

export const getBaseUrl = (path: string, port: string) =>
  ({
    [Environment.Local]: 'http://localhost:' + port + path,
    [Environment.LocalUtveckling]: 'https://legoasutv01.prodstod.se' + path,
    [Environment.Utveckling]: path,
    [Environment.Acceptans]: path,
    [Environment.Stage]: 'https://test.metria.io' + path,
    [Environment.Prod]: 'https://metria.io' + path,
  }[getEnv()]);

